import { render } from "./ProviderReviewTab.vue?vue&type=template&id=6eae5a51&scoped=true"
import script from "./ProviderReviewTab.vue?vue&type=script&lang=js"
export * from "./ProviderReviewTab.vue?vue&type=script&lang=js"

import "./ProviderReviewTab.vue?vue&type=style&index=0&id=6eae5a51&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eae5a51"]])

export default __exports__